import { render, staticRenderFns } from "./CategoriesListView.vue?vue&type=template&id=050f4176&scoped=true&"
import script from "./CategoriesListView.vue?vue&type=script&lang=js&"
export * from "./CategoriesListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f4176",
  null
  
)

export default component.exports